import { hamletUser } from "../../common/hamlet/hamlet-user";

type PersonalizationLoggedInOutParams = {
  showLoggedOutKnownUser: boolean;
  switchFirstName: boolean;
};

export default class PersonalizationLoggedInOut {
  domRoot: HTMLElement;
  params: PersonalizationLoggedInOutParams;
  showLoggedOutKnownUser: boolean;
  switchFirstName: boolean;
  isLoggedIn: boolean;
  loadingState: HTMLElement;
  contentLoggedIn: HTMLElement;
  contentLoggedOut: HTMLElement;
  contentKnownUser: HTMLElement;

  constructor(domRoot: HTMLElement, params: PersonalizationLoggedInOutParams) {
    this.domRoot = domRoot as HTMLElement;
    this.params = params;
    this.showLoggedOutKnownUser = params.showLoggedOutKnownUser;
    this.switchFirstName = params.switchFirstName;
    this.isLoggedIn = false;
    this.loadingState = domRoot.querySelector(".loading-state") as HTMLElement;
    this.contentLoggedIn = domRoot.querySelector(".logged-in") as HTMLElement;
    this.contentLoggedOut = domRoot.querySelector(".logged-out") as HTMLElement;
    this.contentKnownUser = domRoot.querySelector(".logged-out-known-user") as HTMLElement;
    this.init();
  }

  init() {
    const hamletUserCheck = () => {
      return hamletUser.getStargateProfile(true).then(() => {
        this.isLoggedIn = hamletUser.isLoggedIn() || false;
        this.loadingState.style.display = "none";
        if (this.isLoggedIn) {
          this.contentLoggedIn.style.display = "block";
          if (this.switchFirstName) {
            const personalizedStrings = this.contentLoggedIn.querySelectorAll("*");
            Array.from(personalizedStrings).forEach(personalizedString => {
              if (personalizedString.innerText.includes("{firstName}") && personalizedString.children.length == 0) {
                personalizedString.innerText = personalizedString.innerText.replace(/{firstName}/g, hamletUser.getUser().myDetails.firstName);
              }
            })
          }
        } else {
          this.contentLoggedOut.style.display = "block";
        }
      });
    };

    hamletUserCheck();
  }
}
